import { Route, Routes, useLocation } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import { Landing } from '@/pages/Landing';
import { BlogIndex } from '@/pages/BlogIndex';
import { BlogPost } from '@/pages/BlogPost';
import { ToolsIndex } from '@/pages/ToolsIndex';
import { ToolPage } from '@/pages/ToolPage';
import { FaqPage } from '@/pages/FaqPage';
import { LegalPage } from '@/pages/LegalPage';
import { NotFound } from '@/pages/NotFound';
import { Welcome } from '@/pages/Welcome';
import { Call } from '@/pages/Call';
import { WhiteLabel } from '@/pages/WhiteLabel';
import { headFor, useHead } from '@/lib/seo';
import { useLang } from '@/lib/useLang';

/**
 * Le head est recalculé à chaque navigation côté client ; côté serveur il est
 * rendu par `entry-server.tsx` à partir de la même fonction, pour qu'un crawler
 * lise exactement ce qu'un visiteur voit.
 *
 * L'origine passée ici est vide : côté client, les balises canonical servies
 * par le SSR sont déjà dans le document et n'ont pas à être réécrites.
 */
export function App() {
  const lang = useLang();
  const { pathname } = useLocation();
  useHead(headFor(pathname, lang, ''));

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/blog" element={<BlogIndex />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/tools" element={<ToolsIndex />} />
        <Route path="/tools/:slug" element={<ToolPage />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/welcome" element={<Welcome />} />
        <Route path="/call" element={<Call />} />
        <Route path="/white-label" element={<WhiteLabel />} />
        <Route path="/privacy" element={<LegalPage page="privacy" />} />
        <Route path="/terms" element={<LegalPage page="terms" />} />
        {/* Pages exigées par les fiches Chrome Web Store des extensions NeverZero. */}
        <Route path="/extensions/privacy" element={<LegalPage page="extensions-privacy" />} />
        <Route path="/extensions/terms" element={<LegalPage page="extensions-terms" />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
}
